import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { RequestCancellationService } from '../services/request-cancellation.service'
import { catchError, takeUntil } from 'rxjs/operators'
import { throwError } from 'rxjs'
import { AuthService } from '../services/auth.service'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cancellationService = inject(RequestCancellationService)
  const authService = inject(AuthService)

  return next(req).pipe(
    takeUntil(cancellationService.onCancelPendingRequests),
    catchError((error) => {
      if (error.status === 401) {
        authService.logout()
        cancellationService.cancelPendingRequests()
      }

      return throwError(() => error)
    }),
  )
}
